module.exports = __webpack_public_path__ + "media/payment_networks/binance-42a778df.png";